import { createMlGatewayApiClient } from '../client';

import { type MLGatewaySendEvent } from './types';

const client = createMlGatewayApiClient();

export const eventCollectorClient = {
  sendEvent: (data: MLGatewaySendEvent) => client.post('events/send-event', { json: data }),
};
